<template>
    <keep-alive>
      <!-- --------------------------------弃用 弃用 弃用 弃用 弃用 弃用 弃用 弃用 弃用 弃用-------------------------------- -->
        <div class="newsDetailIn">
        <!-- <BC :msg1="location" :msg2="locationAfter" :pathRew="path"></BC> -->
        <BC :msg1="location" :msg2="locationAfter" :pathRew="path" class="detailBC"></BC>
        <h4>{{newsDetail.newsDetail.newsTitle}}</h4>
        <p class="timeAndRemark">发布时间：{{newsDetail.newsDetail.createTime}}<span>发布人：{{newsDetail.newsDetail.remark}}</span></p>
        <div class="content" ref="editor" v-html="newsDetail.newsDetail.newsContent"></div>
        <hr>
        <p class="previous" @click="newsDetail.beforeDetail.createTime == null?$event.preventDefault:go_detail({id:newsDetail.beforeDetail.newsId,type:newsType})">上一篇：{{newsDetail.beforeDetail.newsTitle}}<span>{{newsDetail.beforeDetail.createTime}}</span></p>
        <p class="next" @click="newsDetail.nextDetail.createTime == null?$event.preventDefault:go_detail({id:newsDetail.nextDetail.newsId,type:newsType})">下一篇：{{newsDetail.nextDetail.newsTitle}}<span>{{newsDetail.nextDetail.createTime}}</span></p>
        </div>
    </keep-alive>
</template>

<script>
import BC from '@/components/bc.vue'
import { mapState, mapActions } from 'vuex'

export default {
    data(){
      return{
        location: '新闻资讯',
        locationAfter: '全部新闻',
        path: '/news',
      }
    },
    computed:{
      ...mapState({
        newsDetail: state => state.news.newsDetail,
        newsType: state => state.news.newsType,
      })
    },
    components:{
      BC
    },
    created(){
      if(this.newsType == '0'){
        this.locationAfter = '全部新闻'
      }else if(this.newsType == '1'){
        this.locationAfter = '公司新闻'
      }else if(this.newsType == '2'){
        this.locationAfter = '行业资讯'
      }

      this.$nextTick(this.replaceImgTag)
    },
    methods: {
      ...mapActions({
        go_detail: 'news/go_detail_from_list'
      }),

      replaceImgTag(){
        let oEditor = this.$refs.editor
        let content = oEditor.innerHTML
        console.log('content',content)
        const reg = /<p[^>]*><img[^>]*><\/p>/g
        const matchStr = content.match(reg)
        console.log("matchStr",matchStr)
        const strReg = /<img[^>]*>/g

        if(matchStr != null){
            matchStr.forEach((str, index) => {
            content = content.replace(reg, str.match(strReg)[index])
          })
        }
        oEditor.innerHTML = content
      }
    }
}
</script>

<style lang="scss" scoped>
.newsDetailIn{
    h4,p{
      margin: 0;
    }

    h4{
      font-size: vw(30);
      font-weight: 500;
      padding: vw(18) 0;
      margin-bottom: vw(15);
      border-bottom: 1px solid $grayE7;
    }

    .timeAndRemark{
      font-size: vw(16);
      color: $font66;
    }

    .content ::v-deep {
      margin: vw(30) 0;

      p{
        margin: vw(18) 0 !important;
        line-height: 2;
      }

      p,
      p span{
        font-size: vw(18) !important;
        font-family: SourceHanSansCN-Normal !important;
        text-align: left !important;
        color: $font33 !important;
      }
      
      img{
        max-width: vw(1200) !important;
        padding: vw(22) 0;
      }
    }

    hr{
      height: 1px;
      margin-bottom: vw(27);
      background: $grayE7;
      border: none;
    }

    .previous,
    .next{
      font-size: vw(16);
      text-align: left;
      line-height: 1.875;
      color: $font66;
    }

    .next{
      margin-bottom: vw(222);
    }

    .timeAndRemark,
    .previous,
    .next{
      span{
        padding-left: vw(32);
      }
    }

    .detailBC ::v-deep {
      .el-breadcrumb{
        span{
          &:nth-child(3){
            .el-breadcrumb__inner{
              cursor: pointer;
              font-weight: 700;
              color: $font30;

              &:hover{
                color: $yyBlue !important;
              }
            }
          }
        }
      }
    }//.detailBC

}//.newsDetail
</style>